import styled, { css } from 'styled-components';

interface Props {
  position: boolean;
}

export const DotsContainer = styled.div<Props>`
  position: ${(props): string => (props.position ? 'relative' : 'absolute')};
  margin-top: ${(props): string => (props.position ? '' : '15px')};
  margin-left: ${(props): string => (props.position ? '' : '50px')};
  margin-right: 50px;
`;

export const DotsLoader = styled.div`
  width: 20px;
  height: 5px;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translateX(-50%) translateY(-50%);
`;

const ballCss = css`
  will-change: transform;
  height: 5px;
  width: 5px;
  border-radius: 50%;
  background-color: #009fda;
  position: absolute;
  animation: grow 1s ease-in-out infinite alternate;

  @keyframes grow {
    to {
      transform: translateX(-50%) scale(0);
    }
  }
`;

export const DotOne = styled.div`
  left: 0;
  transform-origin: 100% 50%;
  ${ballCss}
`;

export const DotTwo = styled.div`
  left: 50%;
  transform: translateX(-50%) scale(1);
  ${ballCss}
  animation-delay: 0.33s;
`;

export const DotThree = styled.div`
  right: 0;
  transform-origin: 100% 50%;
  ${ballCss}
  animation-delay: 0.66s;
`;
